import { Component, Input, OnInit, Inject } from '@angular/core';

import { SignalRHubsConnectionToken } from 'rev-shared/push/SignalRHubsConnectionToken';
import { SignalRHubsConnection } from 'rev-shared/push/SignalRHubsConnection';

import styles from './video-comment-container.module.less';
import { VideoPlaybackService } from './VideoPlayback.Service';

@Component({
	selector: 'video-comment-container',
	templateUrl: './VideoCommentContainer.Component.html'
})

export class VideoCommentContainerComponent implements OnInit {
	@Input() public video: any;

	public readonly styles = styles;
	public isAscending: boolean = false;

	constructor(
		@Inject(SignalRHubsConnectionToken)
		private readonly SignalRHubsConnection: SignalRHubsConnection,
		private readonly VideoPlaybackService: VideoPlaybackService
	)
	{}

	public ngOnInit(): void {
		if(!this.SignalRHubsConnection.started) {
			this.VideoPlaybackService.refreshComments()
				.catch(e => {
					console.log('Error loading comments: ', e);
				});
		}

		this.SignalRHubsConnection.start()
			.catch(e => console.error('Error Starting SignalR: ', e));
	}
}
